const getUnionSkillTags = (customSkillTags, ontologySkillTags) => {
    // Filter out ontology tags that have the same idOntology as any custom tag
    const customOntologyIds = customSkillTags.reduce((set, customSkill) => {
        if (customSkill.idOntology !== null) {
            set.add(customSkill.idOntology);
        }
        return set;
    }, new Set());
    const filteredOntologyTags = ontologySkillTags.filter((ontologySkill) => ontologySkill.idOntology !== null &&
        !customOntologyIds.has(ontologySkill.idOntology));
    return [...customSkillTags, ...filteredOntologyTags];
};
export default getUnionSkillTags;
